<template>
  <div class="about-protections">
    <h1 class="about-protections__title title">Detalhamento das coberturas:</h1>

    <h2 class="about-protections__subtitle subtitle">Morte</h2>
    <p class="about-protections__paragraph">Quando tudo está bem, fica difícil imaginar que estamos sujeitos a imprevistos. Mas essa é uma realidade que pode afetar qualquer pessoa. Por isso, as indenizações financeiras contratadas através dos seguros de vida são a garantia de proteção imediata às famílias e a certeza de tranquilidade para o provedor.</p>

    <h3 class="subtitle">O que está garantido?</h3>
    <strong class="about-protections__emphasis">Em caso de morte qualquer causa</strong>
    <p class="about-protections__paragraph">Se você vier a falecer por causas naturais ou acidentais, seus beneficiários vão receber a indenização estipulada no contrato.</p>
    <strong class="about-protections__emphasis">Em caso de morte acidental</strong>
    <p class="about-protections__paragraph">Caso algo aconteça com a sua vida, por conta de um acidente coberto pelo plano, seu beneficiário receberá a indenização financeira contratada.</p>

    <h3 class="subtitle">O que não está garantido?</h3>
    <p class="about-protections__paragraph">Algumas situações não são protegidas pelo seguro de vida. Veja abaixo quais são elas e tire as suas dúvidas:</p>
    <ul class="about-protections__list">
      <li class="about-protections__item">Uso de material nuclear;</li>
      <li class="about-protections__item">Operações de guerra, terrorismo ou de perturbação da ordem pública;</li>
      <li class="about-protections__item">Doenças preexistentes à contratação do seguro que sejam de conhecimento do segurado e não sejam declaradas na proposta de adesão;</li>
      <li class="about-protections__item">Suicídio ou tentativa de suicídio, exceto se ocorrido após o período de 2 (dois) anos contados a partir da vigência inicial do seguro, ou de sua recondução depois de suspenso;</li>
      <li class="about-protections__item">Atos ilícitos dolosos praticados pelo segurado, pelo beneficiário ou pelo representante legal, de um ou de outro;</li>
      <li class="about-protections__item">Acidentes causados por furacões, ciclones, terremotos, maremotos, erupções vulcânicas e outros desastres naturais;</li>
      <li class="about-protections__item">As perturbações e intoxicações alimentares de qualquer espécie, bem como as intoxicações decorrentes da ação de produtos químicos, drogas ou medicamentos, salvo quando prescritos por médico, em decorrência de acidente pessoal.</li>
    </ul>

    <hr>

    <h2 class="about-protections__subtitle subtitle">Invalidez Permanente Total ou Parcial por Acidente (IPA)</h2>
    <p class="about-protections__paragraph">Seguros para invalidez existem para garantir que você poderá arcar com as suas despesas caso, algum acidente ou doença, comprometa a sua capacidade de trabalho.</p>

    <h3 class="subtitle">O que está garantido?</h3>
    <p class="about-protections__paragraph">Você receberá o valor contratado em caso de acidente que cause a perda, redução ou incapacidade de funcionamento de um órgão ou membro, parcial ou totalmente, de forma definitiva.</p>
    <strong class="about-protections__emphasis">Em caso de morte acidental</strong>
    <p class="about-protections__paragraph">Caso algo aconteça com a sua vida, por conta de um acidente coberto pelo plano, seu beneficiário receberá a indenização financeira contratada.</p>
    <h3 class="subtitle">O que não está garantido?</h3>
    <p class="about-protections__paragraph">Algumas situações não são protegidas pelo seguro de vida e, mesmo sendo pouco habituais, é importante que você saiba quais são para que tenha a certeza da escolha que está fazendo. Veja abaixo:</p>
    <ul class="about-protections__list">
      <li class="about-protections__item">Uso de material nuclear;</li>
      <li class="about-protections__item">Operações de guerra, terrorismo ou de perturbação da ordem pública;</li>
      <li class="about-protections__item">Doenças preexistentes à contratação do seguro que sejam de conhecimento do segurado e não sejam declaradas na proposta de adesão;</li>
      <li class="about-protections__item">Suicídio ou tentativa de suicídio, exceto se ocorrido após o período de 2 (dois) anos contados a partir da vigência inicial do seguro, ou de sua recondução depois de suspenso;</li>
      <li class="about-protections__item">Atos ilícitos dolosos praticados pelo segurado, pelo beneficiário ou pelo representante legal, de um ou de outro;</li>
      <li class="about-protections__item">Acidentes causados por furacões, ciclones, terremotos, maremotos, erupções vulcânicas e outros desastres naturais;</li>
      <li class="about-protections__item">As perturbações e intoxicações alimentares de qualquer espécie, bem como as intoxicações decorrentes da ação de produtos químicos, drogas ou medicamentos, salvo quando prescritos por médico, em decorrência de acidente pessoal.</li>
    </ul>

    <hr>

    <h2 class="about-protections__subtitle subtitle">Seguro de Assistência Funeral (SAF)</h2>
    <p class="about-protections__paragraph">Com o <strong>Seguro de Assistência Funeral (SAF)</strong> você tem a certeza de que elas terão apoio para cuidar das providências necessárias neste momento tão difícil.
Ao optar pelo seguro de assistência funeral familiar, seu cônjuge e dependentes menores de 21 anos também estão cobertos por este serviço.</p>

    <h3 class="subtitle">O que está garantido?</h3>
    <ul class="about-protections__list">
      <li class="about-protections__item">Tratamento das formalidades para liberação do corpo e registro em cartório;</li>
      <li class="about-protections__item">Atendimento e organização do funeral, cerimônia fúnebre, sepultamento ou cremação, de acordo com o descrito abaixo:</li>
      <li class="about-protections__item">Translado;</li>
      <li class="about-protections__item">Funeral (urna padrão Busquet, ornamentação da urna, duas coroas de flores, manta mortuária, véu, carro fúnebre, registro em cartório, livro de presença, jogo de paramentos no velório, velas, comunicação em jornal, taxa de sepultamento, taxa de exumação e capela para velório);</li>
      <li class="about-protections__item">Sepultamento;</li>
      <li class="about-protections__item">Cremação;</li>
      <li class="about-protections__item">Transmissão de mensagens urgentes.</li>
    </ul>
    <strong class="about-protections__emphasis">Para acionar os serviços emergenciais ligue para o telefone constante em sua apólice.</strong>
    <strong class="about-protections__emphasis">O que não está garantido?</strong>
    <p class="about-protections__paragraph">Algumas situações não são protegidas por esta mobilidade pelo SAF. É importante que você as conheça para que tenha a certeza da escolha que está fazendo.</p>
    <ul class="about-protections__list">
      <li class="about-protections__item">O embalsamamento (tanatopraxia).</li>
    </ul>

    <p class="about-protections__paragraph">
      <strong>As informações acima prestadas foram resumidas. Para saber detalhadamente tudo o que está garantido pelo seu plano, consulte o regulamento do seguro contratado.</strong>
    </p>
  </div>
</template>

<script>
export default {
  name: "AboutProtections",
  mounted() {
    scrollTo(0,0);
    // schema BreadCrumb
    const schema = {
      "@context": "http://schema.org",
      "@type": "Breadcrumblist",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://www.bralife.com.br"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "sobre",
          "item": "https://www.bralife.com.br/sobre-coberturas"
        }
      ]
    };
    const schemaScriptTag = document.createElement("script");
    schemaScriptTag.setAttribute("type", "application/ld+json");
    schemaScriptTag.innerHTML = JSON.stringify(schema);
    document.querySelector("head").appendChild(schemaScriptTag);
  }
};
</script>

<style scoped lang="scss">
.about-protections {
  max-width: 960px;
  min-height: calc(100vh - 340px); //tamanho da tela menos header e footer
  margin: 0 auto;
  padding: $space__st;
  &__subtitle {
    font-size: $font-size__sp1;
  }
  &__emphasis {
    display: block;
    margin-bottom: $space__md;
  }
  &__paragraph {
    margin-bottom: $space__md;
    text-align: justify;
    text-indent: $space__st;
  }
  &__list {
    margin-left: $space__md;
    list-style: disc;
  }
  &__item {
    margin-bottom: $space__md;
    text-align: justify;
    line-height: 1.5;
  }
}
</style>
